import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { useLanguageStore } from '@/store/languageStore';

const LanguageSwitcher: React.FC = () => {
  const { language, toggleLanguage } = useLanguageStore();
  const { t } = useTranslation('common');

  return (
    <Tooltip
      title={t('actions.toggleLanguage', 'Switch Language')}
      arrow
    >
      <IconButton
        onClick={toggleLanguage}
        color="inherit"
        sx={{
          border: '1px solid',
          borderColor: 'inherit',
          borderRadius: 1,
          width: 40,
          height: 40,
        }}
      >
        <Typography variant="button" sx={{ fontWeight: 'bold' }}>
          {language === 'en' ? 'ع' : 'EN'}
        </Typography>
      </IconButton>
    </Tooltip>
  );
};

export default LanguageSwitcher;
